/* eslint-disable prettier/prettier */
export enum ManageBaseDataKeys {
  SUBSIDIARIES = 'subsidiaries',
  ORGANIZATIONS = 'organizations',
  ORGANIZATION_TYPES = 'organization_types',
  PERPETRATORS = 'perpetrators',
  DEFENSES = 'defenses',
  EXCEPTIONS = 'exceptions',
  JOB_POSITIONS = 'job_positions',
  ORDERS = 'orders',
  DAMAGES = 'damages',
  COUNTRIES = 'countries',
}

export enum ManageBaseInfoKeys {
  ManageBase = 'manage-base',
}